import { BlogWrapper } from "../../../../src/collections/blog/Blog.style.js";
import operator from "../../../../src/collections/blog/2020/2020-08-07-announcing-meshery-v0.4/meshery-operator-dark.svg";
import MesheryArchitecture from "../../../../src/collections/blog/2020/2020-08-07-announcing-meshery-v0.4/meshery-architecture.webp";
import * as React from 'react';
export default {
  BlogWrapper,
  operator,
  MesheryArchitecture,
  React
};